import { spacing, color } from '@upstox/upstox-ui';

export const redHerringCard: CSSFunction = ({ theme }) => ({
  width: '100%',
  marginBottom: spacing(theme, ['medium']),
  '@media (min-width:576px)': {
    marginRight: `${spacing(theme, ['medium'])}!important`,
  },
  '@media (min-width:768px)': {
    // marginBottom: spacing(theme, ['none']),
    width: '432px',
  },

  '@media (min-width:1400px)': {
    marginBottom: spacing(theme, ['none']),
  },
});

export const cardContent: CSSFunction = ({ theme }) => ({
  width: '100%',
  padding: spacing(theme, ['xlarge', 'xlarge', 0, 'xlarge']),
});

export const descriptionText: CSSFunction = ({ theme }) => ({
  margin: spacing(theme, ['xlarge', 0]),
  height: '96px',
});

export const cardStyles: CSSFunction = ({ theme }) => ({
  backgroundColor: color(theme, 'ui1'),
  borderRadius: '8px',
  width: '100%',
});

export const redherringButton: CSSFunction = ({ theme }) => ({
  width: '100%',
  marginBottom: spacing(theme, ['xlarge']),
  '& a': {
    width: '100%',
    height: '44px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #41246E',
    borderRadius: '24px',
  },
});

export const buttonStyles: CSSFunction = ({ theme }) => ({
  padding: spacing(theme, [0]),
  width: '100%',
  background: 'none',
});
